import { applicationPageSvgConst } from "@/src/svg/applicationsPage/applicationsPageSvgExport";

export const onlineApplicationsHeaderSelectConst = [
  {
    id: "ALL",
    title: "All",
    mass: [],
  },
  {
    id: "MALTA",
    title: "Malta",
    mass: [{ name: "All" }, { name: "Marina" }, { name: "Karina" }, { name: "Zoly" }, { name: "Not sorting" }],
  },
  {
    id: "POLAND",
    title: "Poland",
    mass: [{ name: "All PL" }, { name: "Marina PL" }, { name: "Karina PL" }, { name: "Zoly PL" }, { name: "Not sorting" }],
  },
  {
    id: "UKRAINE",
    title: "Ukraine",
    mass: [{ name: "All UA" }, { name: "Marina UA" }, { name: "Karina UA" }, { name: "Zoly UA" }, { name: "Not sorting" }],
  },
];

export const onlineApplicationsFilterStatusesConst = ["All", "New applications", "In Progress", "Follow up", "Done"];

export const onlineApplicationsStarsConst = [
  { color: "default", Icon: applicationPageSvgConst.StarDefaultSvg, description: "default" },
  { color: "black", Icon: applicationPageSvgConst.StarBlackSvg, description: "black" },
  { color: "yellow", Icon: applicationPageSvgConst.StarYellowSvg, description: "yellow" },
  { color: "red", Icon: applicationPageSvgConst.StarRedSvg, description: "red" },
  { color: "green", Icon: applicationPageSvgConst.StarGreenSvg, description: "green" },
  { color: "headBoom", Icon: applicationPageSvgConst.HeadBoomSvg, description: "headBoom" },
  { color: "fingers", Icon: applicationPageSvgConst.FingersSvg, description: "fingers" },
  { color: "money", Icon: applicationPageSvgConst.MoneySvg, description: "money" },
  { color: "stop", Icon: applicationPageSvgConst.StopSvg, description: "stop" },
  { color: "sos", Icon: applicationPageSvgConst.SosSvg, description: "sos" },
];

export const onlineApplicationsStatusConst = [
  { label: "Not sorted", id: "not_sorted" },
  { label: "Clarification", id: "clarification" },
  { label: "In process", id: "in_process" },
  { label: "Admission", id: "admission" },
  { label: "Reservation", id: "reservation" },
  { label: "Invitation", id: "invitation" },
  { label: "Visa app", id: "visa_app" },
];

export const onlineApplicationsStatusTabsConst = [
  { label: "All", id: "All" },
  ...onlineApplicationsStatusConst,
];

export const onlineApplicationsActionsConst = [
  { name: "preview", icon: applicationPageSvgConst.PreviewSvg },
  { name: "comments", icon: applicationPageSvgConst.CommentsSvg },
  { name: "download", icon: applicationPageSvgConst.DownloadSvg },
  { name: "unread", icon: applicationPageSvgConst.UnreadSvg },
  { name: "admissionForward", icon: applicationPageSvgConst.AdmissionForwardSvg },
  { name: "tasks", icon: applicationPageSvgConst.TasksSvg },
  { name: "move", icon: applicationPageSvgConst.DocumentPreparationSvg },
  { name: "delete", icon: applicationPageSvgConst.DeleteSvg },
];

const defaultWidth = 5;
export const onlineApplicationAllFieldsList = [
  { title: "Date", id: "date", width: defaultWidth },
  { title: "Applicant ID", id: "id", width: defaultWidth },
  { title: "ID No", id: "applicant_id", width: defaultWidth },
  { title: "Full Name (EN)", id: "fullName", width: defaultWidth },
  { title: "Date of Birth", id: "dateOfBirth", width: defaultWidth },
  { title: "Status", id: "status", width: defaultWidth },
  { title: "Form Type", id: "type", width: defaultWidth },
  { title: "Email", id: "email", width: defaultWidth },
  { title: "Phone", id: "phone", width: defaultWidth },
  { title: "Country", id: "country", width: defaultWidth },
  { title: "Nationality", id: "nationality", width: defaultWidth },
  { title: "Address", id: "address", width: defaultWidth },
  { title: "Passport No", id: "passportNo", width: defaultWidth },
  { title: "Passport Issued", id: "passportIssued", width: defaultWidth },
  { title: "Valid Passport", id: "validPassport", width: defaultWidth },
  { title: "Degree", id: "levelEducation", width: defaultWidth },
  { title: "Course", id: "course", width: defaultWidth },
  { title: "Updated", id: "updated", width: defaultWidth },
  { title: "Assignee", id: "assignee", width: defaultWidth },
  { title: "Comment", id: "comments", width: defaultWidth },
];

export const onlineApplicationsDefaultConfiguration = [
  { title: "Date", id: "date", width: 4.81 },
  { title: "Applicant ID", id: "id", width: 4.87 },
  { title: "ID No", id: "applicant_id", width: 4.87 },
  { title: "Full Name (EN)", id: "fullName", width: 11.5 },
  { title: "Status", id: "status", width: 6.25 },
  { title: "Form Type", id: "type", width: 6.25 },
  { title: "Email", id: "email", width: 9.69 },
  { title: "Phone", id: "phone", width: 7.44 },
  { title: "Country", id: "country", width: 3.87 },
  { title: "Degree", id: "levelEducation", width: 7.5 },
  { title: "Course", id: "course", width: 8.75 },
  { title: "Updated", id: "updated", width: 5.31 },
  { title: "Assignee", id: "assignee", width: 6 },
  { title: "Comment", id: "comments", width: 12 },
];

export const onlineApplicationsPopUpTabs = [
  { id: "general-information", title: "General Information" },
  { id: "documents", title: "Documents" },
  { id: "comments", title: "Comments" },
  { id: "history", title: "History" },
  { id: "actions", title: "Actions" },
];

export type AOPColumnConfig = {
  title: string;
  id: string;
  width?: number;
};

const findAOPColumn = (id: string): AOPColumnConfig | undefined =>
  onlineApplicationAllFieldsList.find((col) => col.id === id) ??
  onlineApplicationsDefaultConfiguration.find((col) => col.id === id);

const insertAOPColumnBefore = (columns: AOPColumnConfig[], column: AOPColumnConfig, beforeId: string): AOPColumnConfig[] => {
  const beforeIndex = columns.findIndex((col) => col.id === beforeId);
  if (beforeIndex === -1) return [...columns, column];
  const next = [...columns];
  next.splice(beforeIndex, 0, column);
  return next;
};

/** Migrates saved AOPTable: legacy ids, ensures Degree is visible before Course when Course is shown. */
export function normalizeVisibleAOPColumns(columns: AOPColumnConfig[]): AOPColumnConfig[] {
  const knownIds = new Set(onlineApplicationAllFieldsList.map((col) => col.id));

  let next = columns
    .map((col) => {
      if (col.id === "id") return { ...col, title: "Applicant ID" };
      if (col.id === "student_id") return { ...col, id: "applicant_id", title: "ID No" };
      const canonical = findAOPColumn(col.id);
      if (!canonical) return col;
      return { ...canonical, width: col.width ?? canonical.width };
    })
    .filter((col) => knownIds.has(col.id));

  const courseIndex = next.findIndex((col) => col.id === "course");
  let degreeIndex = next.findIndex((col) => col.id === "levelEducation");

  if (courseIndex !== -1 && degreeIndex === -1) {
    const degreeColumn = findAOPColumn("levelEducation");
    if (degreeColumn) {
      next = insertAOPColumnBefore(next, { ...degreeColumn }, "course");
      degreeIndex = next.findIndex((col) => col.id === "levelEducation");
    }
  }

  const updatedCourseIndex = next.findIndex((col) => col.id === "course");
  const updatedDegreeIndex = next.findIndex((col) => col.id === "levelEducation");
  if (updatedCourseIndex !== -1 && updatedDegreeIndex !== -1 && updatedDegreeIndex > updatedCourseIndex) {
    const [degreeColumn] = next.splice(updatedDegreeIndex, 1);
    const courseIdxAfterRemoval = next.findIndex((col) => col.id === "course");
    next.splice(courseIdxAfterRemoval, 0, degreeColumn);
  }

  return next;
}
